import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Image, Modal } from 'semantic-ui-react';
import ReactGA from 'react-ga';

import BrowseUniversity from './BrowseUniversity';

export default class BrowseUniversityModal extends Component {
  static propTypes = {
    trigger: PropTypes.element,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    trigger: <Button>Show Modal</Button>,
    onClose: () => {},
  };

  state = {
    modalOpen: false,
  };

  closeModal = () => {
    this.setState(prevState => ({ modalOpen: false }));
    this.props.onClose();
    try {
      ReactGA.event({
        category: 'BROWSE_UNIVERSITY',
        action: 'Modal close',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
  };

  openModal = () => {
    this.setState(prevState => ({ modalOpen: true }));
    try {
      ReactGA.event({
        category: 'BROWSE_UNIVERSITY',
        action: 'Modal open',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
  };

  renderTrigger = () => {
    return React.cloneElement(this.props.trigger, { onClick: this.openModal });
  };

  render() {
    const { mockExam, hideHeart, roundCode } = this.props;
    return (
      <Modal
        className={'scrolling'}
        trigger={this.renderTrigger()}
        dimmer="inverted"
        open={this.state.modalOpen}
      >
        <Modal.Content>
          <BrowseUniversity
            mockExam={mockExam}
            hideHeart={hideHeart}
            roundCode={roundCode}
            showClose
            onClose={this.closeModal}
          />
        </Modal.Content>
      </Modal>
    );
  }
}
